require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-health-savings-accounts.json") })
        }
      }, "path---articles-health-savings-accounts");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-health-savings-accounts!./.cache/json/articles-health-savings-accounts.json
// module id = 1686
// module chunks = 231608221292675